import classNames from 'classnames';
import React from 'react';
import { statusLabel, TaskStatus } from './tasks';

const STATUS_BADGES: Record<TaskStatus, string> = {
  active: 'bg-dl-success-tint text-dl-success ring-dl-success/20',
  computing: 'bg-dl-tint text-dl-accent ring-dl-accent/20',
  'compute-error': 'bg-dl-danger-tint text-dl-danger ring-dl-danger/20',
  importing: 'bg-dl-warning-tint text-dl-warning ring-dl-warning/20',
  'import-error': 'bg-dl-danger-tint text-dl-danger ring-dl-danger/20',
  disabled: 'bg-dl-sunken text-dl-muted ring-dl-border',
};

export function StatusBadge({ status }: { status: TaskStatus }) {
  return (
    <span
      className={classNames(
        'inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-sm font-medium ring-1 ring-inset',
        STATUS_BADGES[status]
      )}
    >
      {statusLabel(status)}
    </span>
  );
}

/** The latest computation of the task's items recorded issues: how many, for the list and the drawer. */
export function IssuesIndicator({ issues }: { issues: number }) {
  if (issues <= 0) {
    return null;
  }
  return (
    <span
      title={`The latest computation of its items recorded ${issues.toLocaleString()} issue(s)`}
      className="inline-flex whitespace-nowrap rounded-full bg-dl-warning-tint px-2 py-0.5 text-xs font-medium text-dl-warning ring-1 ring-inset ring-dl-warning/20"
    >
      {issues.toLocaleString()} {issues === 1 ? 'issue' : 'issues'}
    </span>
  );
}
